import { useGroupConfigurations } from 'hooks/useGroupConfig';
import { useUser } from 'state/auth';
import { useDashboardGroupId } from 'state/dashboard';
import type { GroupConfigMinimal } from 'services/API/GroupConfigurationAPI';

/** The currently selected saved search (from the map's saved-search dropdown), if any. */
export const useSelectedGroupConfig = (): GroupConfigMinimal | undefined => {
  const [dashboardGroupId] = useDashboardGroupId();
  const { user } = useUser();
  const { data: groupConfigs } = useGroupConfigurations({ userId: String(user?.id) });

  return groupConfigs?.find((group) => group.id === Number(dashboardGroupId));
};
